// test406
(406 && 0);
